// ---------------------------------------------------------------------------
// FAQ Accordion Renderer
// ---------------------------------------------------------------------------

import { registerRenderer } from "../registry.js";
import type { RenderContext } from "../types.js";
import { attr, text } from "../escape.js";

interface FaqItem {
  question: string;
  answer: string;
}

interface FaqAccordionProps {
  heading?: string;
  items: FaqItem[];
  openFirst?: boolean;
}

function render(props: Record<string, unknown>, _ctx: RenderContext): string {
  const p = props as unknown as FaqAccordionProps;

  const heading = p.heading ?? "Frequently Asked Questions";
  const items = Array.isArray(p.items) ? p.items : [];
  const openFirst = p.openFirst !== false;

  const headingHtml = `<h2 class="ease-faq-heading">${text(heading)}</h2>`;

  const itemsHtml = items
    .map((item, i) => {
      const isOpen = openFirst && i === 0;
      const btnId = `ease-faq-btn-${i}`;
      const panelId = `ease-faq-panel-${i}`;

      return `    <div class="ease-faq-item">
      <h3>
        <button id="${attr(btnId)}" class="ease-faq-trigger" type="button" aria-expanded="${attr(String(isOpen))}" aria-controls="${attr(panelId)}">
          ${text(item.question)}
        </button>
      </h3>
      <div id="${attr(panelId)}" class="ease-faq-panel" role="region" aria-labelledby="${attr(btnId)}"${isOpen ? "" : ' hidden'}>
        <p>${text(item.answer)}</p>
      </div>
    </div>`;
    })
    .join("\n");

  const script = `<script>(function(){var btns=document.querySelectorAll('.ease-faq-trigger');btns.forEach(function(btn){btn.addEventListener('click',function(){var expanded=btn.getAttribute('aria-expanded')==='true';btn.setAttribute('aria-expanded',String(!expanded));var panel=document.getElementById(btn.getAttribute('aria-controls'));if(panel){expanded?panel.setAttribute('hidden',''):panel.removeAttribute('hidden');}});});})()</script>`;

  return `<section class="ease-section ease-faq-accordion" aria-label="${attr(heading)}">
  ${headingHtml}
  <div class="ease-faq-list">
${itemsHtml}
  </div>
</section>
${script}`;
}

registerRenderer("faq-accordion", { render });
